import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { CLOSE } from '@Images';

const Modal = styled.div`
  width: 850px;
  height: 90%;
  border-radius: 5px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
  background-color: ${COLORS.white};
  padding: 50px 20px 20px 40px;
  @media only screen and (max-width: 1024px) {
    padding: 32px 20px 20px 10px;
  }
  overflow: auto;
`;

const CloseImage = styled.div`
  display: flex;
  justify-content: flex-end;

  > img {
    cursor: pointer;
    height: 16px;
    width: 16px;
  }
`;

const Title = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.black};
  padding-left: 20px;
  padding-bottom: 20px;

  > span {
    font-size: 16px;
    font-weight: 500;
  }
`;

const ListContainer = styled.ul`
  line-height: 17px;
  padding-left: 20px;
  letter-spacing: 0.34px;
`;

const List = styled.li`
  font-size: 16px;
  color: ${COLORS.textGrey};
  padding-top: 10px;
  font-family: ${FONT_FAMILY.hellix.regular};
  ${(p) => p.header && 'background: #E5FEFF'};
`;

const CashPickupLocation = ({ locationData, onClose }) => {
  return (
    <Modal>
      <CloseImage>
        <img onClick={() => onClose(true)} alt={'close'} src={CLOSE}></img>
      </CloseImage>
      <Title>
        Available Cash Pickup Partners <span>with transfer limit of Php 50,000.00</span>
      </Title>
      <ListContainer>
        <List header={true}>Pickup Partners Including Banks</List>
        {locationData &&
          locationData.map((item, index) => {
            return <List key={index}>{item.text}</List>;
          })}
      </ListContainer>
    </Modal>
  );
};

CashPickupLocation.propTypes = {
  onClose: PropTypes.func,
  locationData: PropTypes.any
};

export default CashPickupLocation;
